/* Generic product page: variant matching (any number of options) + gallery thumbnails.
   Add-to-cart submission itself is handled globally by theme.js's initAddToCartForms. */

document.addEventListener('DOMContentLoaded', function () {
  var form = document.querySelector('[data-product-form]');
  if (!form) return;

  var jsonEl = document.querySelector('[data-product-json]');
  var variants = [];
  try { variants = JSON.parse(jsonEl.textContent); } catch (e) { variants = []; }
  if (!variants.length) return;

  var variantIdInput = form.querySelector('[data-variant-id]');
  var priceEl = document.querySelector('[data-price]');
  var compareEl = document.querySelector('[data-compare-price]');
  var submitBtn = form.querySelector('[data-add-to-cart-button]');

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function selectedOptions() {
    var byIndex = {};
    form.querySelectorAll('[data-option-input]:checked').forEach(function (el) {
      byIndex[el.dataset.optionIndex] = el.value;
    });
    var indexes = Object.keys(byIndex).map(Number).sort(function (a, b) { return a - b; });
    return indexes.map(function (i) { return byIndex[i]; });
  }

  function findVariant() {
    var selected = selectedOptions();
    if (!selected.length) return variants[0];
    return variants.find(function (v) {
      return selected.every(function (value, i) { return v.options[i] === value; });
    }) || null;
  }

  function updateUI() {
    var variant = findVariant();

    if (!variant) {
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Unavailable'; }
      return;
    }

    if (variantIdInput) variantIdInput.value = variant.id;
    if (priceEl) priceEl.textContent = formatMoney(variant.price);

    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }

    if (submitBtn) {
      submitBtn.disabled = !variant.available;
      submitBtn.textContent = variant.available ? 'Add to bag' : 'Sold out';
    }
  }

  form.querySelectorAll('[data-option-input]').forEach(function (input) {
    input.addEventListener('change', updateUI);
  });

  updateUI();

  var mainImage = document.querySelector('[data-gallery-main-image]');
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (mainImage) mainImage.src = thumb.dataset.image;
      document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });
});
